import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const BlogSection = () => {
  return (
    <div>
      <Navbar />
      <div className="flex flex-col lg:flex-row gap-6 px-6 lg:px-16 py-8 bg-gray-50">
        {/* Main Blog Section */}
        <div className="lg:w-2/3 space-y-6">
          {/* Blog Card 1 */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800">
              Efficient Energy Solutions: A Case Study of a 6.2kW Solar
              Installation in Lagos
            </h2>
            <p className="text-gray-600 mt-2">
              As energy prices rise and the demand for reliable electricity
              grows, solar power has become a practical solution for homes and
              businesses in Nigeria. In this post, we highlight a recent
              installation by Solaris Surge Energy Solutions Ltd for a hotel in
              Lagos, showcasing how solar energy can revolutionize power supply,
              reduce costs, and support sustainability.
            </p>
            <button className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded hover:bg-blue-700">
              <Link to="/bloglayout">Continue reading</Link>
            </button>
          </div>

          {/* Blog Card 2 */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800">
              Do You Need A Shunt If You Have A BMS?
            </h2>
            <p className="text-gray-600 mt-2">
              A Battery Management System (BMS) often uses a device called a
              Hall effect sensor to measure the current flowing in and out of
              your battery. This sensor is crucial because it helps the BMS
              monitor how the battery is being ...
            </p>
            <button className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded hover:bg-blue-700">
              <Link to="/bloglayout2"> Continue reading</Link>
            </button>
          </div>

          {/* Blog Card 3 */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800">
              How to Connect Two Solar Panels to one Battery
            </h2>
            <p className="text-gray-600 mt-2">
              Connecting two solar panels to one battery with one charge
              controller is easy. This article will explain how you do it,
              including schematics. First of all, you should know this: When you
              connect your solar panels directly to your …
            </p>
            <button className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded hover:bg-blue-700">
              <Link to="/bloglayout3"> Continue reading</Link>
            </button>
          </div>
          {/* Blog Card 4 */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800">
              Difference Between Victron BMV-700 and BMV-712
            </h2>
            <p className="text-gray-600 mt-2">
              The Victron BMV-712 and BMV-700 battery monitors offer distinct
              features to cater to different user needs: Additional Features of
              BMV-712 Multiple Battery Monitoring The BMV-712 can monitor
              multiple batteries. It does this by using the second output of the
              Shunt …
            </p>
            <button className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded hover:bg-blue-700">
              Continue reading
            </button>
          </div>
          {/* Blog Card 5 */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800">
              Grounding and Bonding for Vans
            </h2>
            <p className="text-gray-600 mt-2">
              This article will educate you about grounding and bonding in your
              van. First, we need to know some definitions. Then, I will explain
              using a residual current device, the difference in electrical
              networks, and the neutral-to-earth link or NEM in …
            </p>
            <button className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded hover:bg-blue-700">
              Continue reading
            </button>
          </div>
          {/* Blog Card 6 */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800">
              Wiring two shunts in Series – More than one Shunt
            </h2>
            <p className="text-gray-600 mt-2">
              Yes, it’s possible to wire two shunts in series in one battery
              system. Typically, a second shunt is needed to monitor a different
              circuit. Suppose you need to use two shunts in a single battery
              system to measure the current …
            </p>
            <button className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded hover:bg-blue-700">
              Continue reading
            </button>
          </div>
          {/* Blog Card 7 */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800">
              Difference Between Victron BMV-700 and BMV-702?
            </h2>
            <p className="text-gray-600 mt-2">
              The BMV-702 distinguishes itself by monitoring a second battery’s
              voltage, crucial for multi-battery systems, and providing extra
              inputs for midpoint voltage or temperature monitoring. the Victron
              BMV-700 and BMV-702 are well-known battery monitors in the Victron
              Energy lineup, popular among …
            </p>
            <button className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded hover:bg-blue-700">
              Continue reading
            </button>
          </div>
          {/* Blog Card 8 */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800">
              Aili Battery Monitor Review
            </h2>
            <p className="text-gray-600 mt-2">
              In my journey of creating tutorials on off-grid living, I’ve come
              across various battery monitors, but the AiLi Battery Monitor
              stands out for its versatility and reliability. It’s a gem for
              anyone delving into off-grid setups, offering a broad voltage …
            </p>
            <button className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded hover:bg-blue-700">
              Continue reading
            </button>
          </div>
          {/* Blog Card 9 */}
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800">
              The Difference Between DC to DC Charger a Split Charge Relay and a
              VSR
            </h2>
            <p className="text-gray-600 mt-2">
              The difference between a DC-to-DC charger and a split charge relay
              lies in their functionality, efficiency, and how they charge
              batteries in vehicles, particularly in dual battery systems often
              used in RVs, boats, and off-grid setups. What is a DC …
            </p>
            <button className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded hover:bg-blue-700">
              Continue reading
            </button>
          </div>
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800">
              DC to DC Battery Charger Off-Grid Solar
            </h2>
            <p className="text-gray-600 mt-2">
              Voltage Regulation: B2B chargers take DC input from a source
              battery and convert it to a suitable DC output voltage to charge a
              secondary battery. They ensure that the charging voltage is
              appropriate for the battery type and state. Isolation: …
            </p>
            <button className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded hover:bg-blue-700">
              Continue reading
            </button>
          </div>
        </div>

        {/* Sidebar Section */}
        <div className="lg:w-1/3 bg-white shadow-md rounded-lg p-6">
          <div className="flex flex-col items-center">
            <img
              src="/Assets/man.webp"
              alt="Profile"
              className="rounded-full w-32 h-32 mb-4"
            />
            <h3 className="text-xl font-semibold text-gray-800">About Me</h3>
            <p className="text-gray-600 text-center mt-4">
              Welcome to Solarissurge.net! I'm the driving force behind this
              site, which attracts over 1,000 daily visitors interested in solar
              energy. I'm also the author of a popular solar energy book, with
              over 80,000 copies sold and more than 2,000 reviews averaging 4.5
              stars. My mission is to demystify solar power and make it
              accessible to everyone. Join me in exploring the potential of
              solar power to create a cleaner, brighter future! Link to the book
              on Amazon.{" "}
              <Link
                className=" text-green-500 hover:underline"
                to="/aboutmesection"
              >
                Read more about me here,
              </Link>{" "}
              check out my{" "}
              <Link
                className=" text-green-500 hover:underline"
                to="https://www.youtube.com/@odedeyidamilare"
              >
                Youtube channel
              </Link>
              , or{" "}
              <Link
                className=" text-green-500 hover:underline"
                to="/contactsection"
              >
                send me a message.
              </Link>
            </p>
          </div>
        </div>
      </div>
      <a
        href="https://wa.me/+2348165213568?text=Hi!%20I%20have%20a%20query."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-200"
      >
        <img
          src="/Assets/chat.png" // <-- Replace this with the actual image path or URL from Flaticon
          alt="WhatsApp Chat"
          className="w-8 h-8" // Tailwind sizes (e.g., w-6 = 24px)
        />
      </a>
      <Footer />
    </div>
  );
};

export default BlogSection;
